import { DSTextArea } from '@repo/design-system/index'
import { QIcon_outlink } from '@repo/icons/index'
import { useRef, useState } from 'react'
import { useCustomerType } from '../../modules/apis/student/products'
import { useLocale } from '../../modules/context/LocaleContext'
import { APP_SCREEN_NAME } from '../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../modules/hooks/common/useAppRouter'
import useIsWebview from '../../modules/hooks/common/useIsWebview'
import { LOCALE_EN, LOCALE_KO } from '../../modules/i18n/config'
import {
  n_lesson_review,
  n_upcoming_lessons,
  s_lesson_style,
  s_upcoming_lessons,
} from '../../modules/i18n/strings/auto/wording'
import { n_system } from '../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../modules/i18n/useTranslation'
import { ICON_CHECKBOX_ACTIVE, ICON_CHECKBOX_INACTIVE } from '../../modules/svg/svg'
import { locationMoveLocaleNewTab } from '../../modules/utils'
import { COLORS } from '../../modules/vars'
import RadioGroupComponent from '../_legacy/RadioGroupComponent'
import Div from '../basic/Div'

export const lessonRadioGroup1 = ({ t, readOnly = false }) => {
  return {
    radioGroup: {
      name: 'option',
      items: [
        {
          name: (
            <>
              <div className="text-[14px]">{t(n_upcoming_lessons.lesson_style.mode_correction_instant)}</div>
              <div className="text-[12px] text-gray-500">
                {t(n_upcoming_lessons.lesson_style.mode_correction_instant_info)}
              </div>
            </>
          ),
          value: 0,
          disabled: readOnly,
        },
        {
          name: (
            <>
              <div className="text-[14px]">{t(n_upcoming_lessons.lesson_style.mode_correction_intermittent)}</div>
              <div className="text-[12px] text-gray-500">
                {t(n_upcoming_lessons.lesson_style.mode_correction_intermittent_info)}
              </div>
            </>
          ),
          value: 1,
          disabled: readOnly,
        },
      ],
    },
  }
}
export const lessonRadioGroup2 = ({ t, readOnly = false }) => {
  return {
    radioGroup: {
      name: 'option',
      items: [
        {
          name: (
            <>
              <div className="text-[14px]">{t(s_upcoming_lessons.discussion_55)}</div>
              <div className="text-[12px] text-gray-500">{t(s_upcoming_lessons.half_talk)}</div>
            </>
          ),
          value: 0,
          disabled: readOnly,
        },
        {
          name: (
            <>
              <div className="text-[14px]">{t(s_upcoming_lessons.discussion_82)}</div>
              <div className="text-[12px] text-gray-500">{t(s_upcoming_lessons.i_mainly_talk)}</div>
            </>
          ),
          value: 1,
          disabled: readOnly,
        },
      ],
    },
  }
}

/**
 *
 * @param fixedToNo : true 일 경우, toggle을 눌러도 체크가 안되게 함 & 특정 조건일 때 No로 고정
 *
 */
const ToggleTabDisabled = (props: { leftLabel; rightLabel; defaultChecked }) => {
  const { leftLabel, rightLabel, defaultChecked } = props
  const checkedCLX =
    'border-1 flex flex-1 flex-row items-center justify-center rounded-[8px] border-gray-200 py-[8px] px-[12px]'
  const notCheckedCLX = 'flex flex-1 flex-row items-center justify-center rounded-[8px] bg-gray-200 py-[8px] px-[12px]'
  return (
    <div className={'flex flex-row gap-[8px] whitespace-nowrap py-[12px] font-medium text-gray-500'}>
      <div className={defaultChecked ? checkedCLX : notCheckedCLX}>{leftLabel}</div>
      <div className={!defaultChecked ? checkedCLX : notCheckedCLX}>{rightLabel}</div>
    </div>
  )
}

type LessonStylePopupBodyPropsType = {
  item: any
  isWriting?: boolean
}
const MessageLine = ({ message }: { message: string }) => {
  return (
    <div className="text-[14px] text-gray-500">
      • {message}
      <br />
    </div>
  )
}
const LessonStyleViewPopupBody = ({ item, isWriting }: LessonStylePopupBodyPropsType) => {
  const introRef = useRef<HTMLTextAreaElement>(null)
  const { t, isLocaleKO } = useTranslation()
  const { data: customerType } = useCustomerType()
  const [allowRecord, setAllowRecord] = useState(item.allow_record != null ? item.allow_record : false)
  const [allowCAF, setAllowCAF] = useState(item.allow_caf != null ? item.allow_caf : false)
  const [skipIntro, setSkipIntro] = useState(item.intro.skip_intro_user != null ? item.intro.skip_intro_user : true)
  const [lessonMode, setLessonMode] = useState(item.lesson_mode.mode != null ? item.lesson_mode.mode : 0)
  const [lessonOption, setLessonOption] = useState(item.lesson_mode.option != null ? item.lesson_mode.option : 0)
  const [selectedRequest, setSelectRequest] = useState(item.selectable_requests)
  const [intensiveArea, setIntensiveArea] = useState(item.intensive_area)

  const isWebview = useIsWebview()
  const router = useAppRouter()

  const CAFChoose = () => {
    const { locale } = useLocale()
    const { t } = useTranslation()

    const onClickWhatIsCAF = () => {
      if (isWebview) {
        if (isLocaleKO) {
          router.push('', {
            appScreenName: APP_SCREEN_NAME.OUTLINK_SCREEN,
            appSendData: {
              url: 'https://www.ringleplus.com/ko/student/landing/blog/ai-analysis-about',
            },
          })
        } else {
          router.push('', {
            appScreenName: APP_SCREEN_NAME.OUTLINK_SCREEN,
            appSendData: {
              url: 'https://www.ringleplus.com/en/student/landing/blog/ai-analysis-about-eng',
            },
          })
        }
      } else {
        const cafLink = t([
          '/student/landing/blog/ai-analysis-about',
          '/student/landing/blog/ai-analysis-about-eng',
          '',
          '/student/landing/blog/english-related-17',
          '/student/landing/blog/english-related-13',
          '/student/landing/blog/ai-analysis-about-eng',
          '',
        ])
        locationMoveLocaleNewTab(cafLink)
      }
    }

    return (
      <div className="mb-[32px]">
        <div className="mb-[8px] mt-[16px] flex items-center justify-between">
          <div className="text-[16px] font-medium">{t(n_upcoming_lessons.lesson_style.analysis_title)}</div>
          {(locale == LOCALE_KO || locale == LOCALE_EN) && (
            <div className="flex items-center justify-end gap-[4px] hover:cursor-pointer" onClick={onClickWhatIsCAF}>
              <div className="text-gray-600">{t(n_system.lesson_style_caf)}</div>
              <QIcon_outlink width={15} height={15} />
            </div>
          )}
        </div>

        <ToggleTabDisabled
          defaultChecked={allowCAF}
          leftLabel={t(s_upcoming_lessons.caf_menu.optn1)}
          rightLabel={t(s_upcoming_lessons.caf_menu.optn2)}
        />
        {isWriting && <MessageLine message={t(n_lesson_review.ai_status_title4)} />}
      </div>
    )
  }

  const RecordChoose = ({ item, isMulticampus }) => {
    const { t } = useTranslation()

    return (
      <div>
        <div className="mb-[8px]  mt-[16px] text-[16px] font-medium">
          {t(n_upcoming_lessons.lesson_style.record_title)}
        </div>
        {/* 체험수업 아닐시 */}
        <ToggleTabDisabled
          defaultChecked={allowRecord}
          leftLabel={t(n_upcoming_lessons.lesson_style.record_yes)}
          rightLabel={t(n_upcoming_lessons.lesson_style.record_no)}
        />
        <div className="mb-[32px] mt-[8px] font-normal text-gray-500">
          {!isMulticampus && <MessageLine message={t(n_upcoming_lessons.lesson_style.record_info1)} />}
          {item.trial && <MessageLine message={t(n_upcoming_lessons.lesson_style.record_info2)} />}
          {!item.trial && <MessageLine message={t(s_upcoming_lessons.mp3_warning_danger)} />}
        </div>
      </div>
    )
  }

  const IntroChoose = ({ item }) => {
    const { t } = useTranslation()

    return (
      <div className="mb-[32px]">
        <div className="mb-[8px] text-[16px] font-medium">{t(s_lesson_style.intro.title)}</div>
        <ToggleTabDisabled
          defaultChecked={skipIntro}
          leftLabel={t(s_lesson_style.intro.skip)}
          rightLabel={t(s_lesson_style.intro.do)}
        />
        {skipIntro && (
          <div className="flex flex-col break-normal">
            <textarea
              ref={introRef}
              rows={5}
              defaultValue={item.intro.desc}
              placeholder={t(s_lesson_style.intro.placeholder)}
              disabled
              style={{
                fontSize: '14px',
                height: '120px',
                borderColor: COLORS.WHITE,
                borderRadius: 8,
                backgroundColor: COLORS.GRAY50,
              }}
              className="mt-4 p-16"
            />
          </div>
        )}
      </div>
    )
  }

  // 수업모드
  const OptionChoose = ({ item }) => {
    const { t } = useTranslation()

    return (
      <div className="mb-[36px]">
        <div className="mb-[8px] text-[16px] font-medium">{t(s_lesson_style.lesson_mode.title)}</div>
        <ToggleTabDisabled
          defaultChecked={lessonMode == 0 ? true : false}
          leftLabel={t(s_lesson_style.lesson_mode.correction)}
          rightLabel={t(s_lesson_style.lesson_mode.discussion)}
        />
        {lessonMode == 0 ? (
          <RadioGroupComponent
            settings={lessonRadioGroup1({ t, readOnly: true }).radioGroup.items}
            selected={lessonOption}
            setSelected={() => null}
          />
        ) : (
          <RadioGroupComponent
            settings={lessonRadioGroup2({ t, readOnly: true }).radioGroup.items}
            selected={lessonOption}
            setSelected={() => null}
          />
        )}
      </div>
    )
  }

  return (
    <div className="px-[8px]">
      {item.lesson && (
        <div>
          <RecordChoose isMulticampus={customerType?.isMulticampus} item={item} />
          <CAFChoose />
          <IntroChoose item={item} />
          {item.trial ? (
            <>
              <div className="mb-[12px] text-[16px] font-medium">{t(s_lesson_style.lesson_mode.title)}</div>
              <div className="mb-[32px] text-[12px] text-gray-500">{t(s_upcoming_lessons.desc_about_tiral_lesson)}</div>
            </>
          ) : (
            <OptionChoose item={item} />
          )}
          <div className="mb-[32px]">
            <div>
              <div className="mb-[20px] text-[16px] font-medium">{t(s_lesson_style.intensive_focus.title)}</div>
              <IntensiveChoose item={item} intensiveArea={intensiveArea} />
            </div>
          </div>
          <div>
            <div className="mb-[8px] text-[16px] font-medium">{t(s_lesson_style.additional_request.title)}</div>
            <RequestChoose item={item} readOnly={true} selectedRequest={selectedRequest} />
            <div className="mb-[8px] text-[16px] font-medium">{t(s_upcoming_lessons.addi_request)}</div>
            <AdditionalInput otherRequest={item.other_request} />
            <div className="h-[74px]" />
          </div>
        </div>
      )}
    </div>
  )
}
export default LessonStyleViewPopupBody

type IntensiveChoosePropsType = {
  item: any
  intensiveArea: any
}

export const IntensiveChoose = ({ item, intensiveArea }: IntensiveChoosePropsType) => {
  return (
    <div className="grid grid-cols-2 justify-start gap-y-[16px] sm:flex sm:flex-col">
      {item.intensive_area.map((v, i) => (
        <div key={i} className="mr-[16px] flex flex-row">
          <CheckBoxDisabled
            checked={v.selected}
            label={
              <label htmlFor={`intensive-${v.id}`}>
                <div className="mr-[45px] text-[14px] font-normal text-black">{v.title}</div>
              </label>
            }
          />
        </div>
      ))}
    </div>
  )
}

type RequestChoosePropsType = {
  item: any
  selectedRequest: any
  readOnly?: boolean
}

const RequestChoose = ({ item, selectedRequest, readOnly }: RequestChoosePropsType) => {
  const { isLocaleKO } = useTranslation()

  return (
    <div className="mb-[32px]">
      {item.selectable_requests.map((item, i) => (
        <div key={i} onClick={null} className="border-b-1 border-gray mr-[16px] sm:border-none  ">
          <CheckBoxDisabled
            checked={selectedRequest[i].selected}
            label={
              <label className="custom-control-label display-9" htmlFor={`selectable-${item.id}`}>
                <div className="mt-[12px] mb-[4px] text-[14px] font-normal text-black">
                  {isLocaleKO ? item.contentKor : item.content}
                </div>
              </label>
            }
          />
        </div>
      ))}
    </div>
  )
}
interface CheckBoxDisabledType {
  checked: boolean | undefined
  label: any
}
const CheckBoxDisabled: React.FC<CheckBoxDisabledType> = ({ checked, label }) => {
  return (
    <Div cursorPointer={false} flex itemsCenter textGray600 mb8>
      {checked ? (
        <img style={{ width: '24px', height: '24px', maxWidth: 'none', opacity: 0.6 }} src={ICON_CHECKBOX_ACTIVE} />
      ) : (
        <img style={{ width: '24px', height: '24px', maxWidth: 'none', opacity: 0.6 }} src={ICON_CHECKBOX_INACTIVE} />
      )}
      <h5 className="text-h5 ml-[8px] text-left text-gray-700">{label}</h5>
    </Div>
  )
}

type AdditionalInputPropsType = {
  otherRequest: any
}

const AdditionalInput = ({ otherRequest }: AdditionalInputPropsType) => {
  const { t } = useTranslation()
  return (
    <DSTextArea
      value={otherRequest}
      setValue={otherRequest}
      name={'AdditionalInput'}
      placeholder={t(n_upcoming_lessons.lesson_style.other_request_placeholder)}
    ></DSTextArea>
  )
  // <div className="w-full rounded-[8px] bg-gray-50 p-[16px] text-gray-400">{otherRequest}</div>
}
